import { render, staticRenderFns } from "./SendBackReasonDialog.vue?vue&type=template&id=3f8dae6f&scoped=true&"
import script from "./SendBackReasonDialog.vue?vue&type=script&lang=js&"
export * from "./SendBackReasonDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendBackReasonDialog.vue?vue&type=style&index=0&id=3f8dae6f&lang=scss&scoped=true&"
import style1 from "./SendBackReasonDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8dae6f",
  null
  
)

export default component.exports